<div class="root" *transloco="let t; read:'permit'">
    <h2 class="root__question-text" [innerHTML]="t('validTime.heading')"></h2>

    <div *ngIf="comment" class="root__comment" [innerHTML]="comment"></div>

    <div *ngIf="(isPremium$ | async) === false" class="root__info">{{ t("validTime.info") }}</div>
    <div *ngIf="(isPremium$ | async) === true" class="root__info"[innerHTML]="t('validTime.premiumInfo', { time: (workplaceDetails$ | async)?.permitDuration })"></div>

    <div *ngIf="(canStartPermit$ | async) === false" class="root__error">{{ t("validTime.relatedFlammableAtexPermitNotStarted") }}</div>
    <div *ngIf="startPermitErrorMessage$ | async as startPermitErrorMessage" class="root__error">{{ startPermitErrorMessage }}</div>

    <div class="root__date" [innerHTML]="t('validTime.date', { date: validDateTime | haDate: 'dateTimeStandard' })"></div>

    <form [formGroup]="form">
        <input type="hidden" formControlName="validDateTime">
    </form>

    <button class="root__actions__update-time" (click)="showUpdateTimeModal()">{{ t("validTime.change") }}</button>

    <div class="root__actions">
        <button class="root__actions__back" type="button" (click)="goBack()">{{ t("back") }}</button>
        <button class="root__actions__continue" type="button" (click)="start()" [disabled]="!canProceed || (canStartPermit$ | async) === false" [class.root__actions__continue--disabled]="!canProceed || (canStartPermit$ | async) === false" [loading]="startPermitAction">
            {{ t("validTime.start") }}
        </button>
    </div>
</div>
